/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import * as zod from 'zod';

export const listQuotationsParamsItemsPerPageDefault = 25;
export const listQuotationsParamsItemsPerPageMax = 1000;

export const listQuotationsParamsPageDefault = 1;
export const ListQuotationsParams = zod.object({
  "created_at[eq]": zod.iso.datetime({"offset":true}).optional(),
  "created_at[ne]": zod.iso.datetime({"offset":true}).optional(),
  "created_at[gt]": zod.iso.datetime({"offset":true}).optional(),
  "created_at[gte]": zod.iso.datetime({"offset":true}).optional(),
  "created_at[lt]": zod.iso.datetime({"offset":true}).optional(),
  "created_at[lte]": zod.iso.datetime({"offset":true}).optional(),
  "created_at[in]": zod.array(zod.iso.datetime({"offset":true})).optional(),
  "created_at[nin]": zod.array(zod.iso.datetime({"offset":true})).optional(),
  "created_at[null]": zod.boolean().optional(),
  "identifier[eq]": zod.string().optional(),
  "identifier[ne]": zod.string().optional(),
  "identifier[in]": zod.array(zod.string()).optional(),
  "identifier[nin]": zod.array(zod.string()).optional(),
  "identifier[null]": zod.boolean().optional(),
  "identifier[cont]": zod.string().optional(),
  "identifier[start]": zod.string().optional(),
  "identifier[end]": zod.string().optional(),
  "name[eq]": zod.string().optional(),
  "name[ne]": zod.string().optional(),
  "name[in]": zod.array(zod.string()).optional(),
  "name[nin]": zod.array(zod.string()).optional(),
  "name[null]": zod.boolean().optional(),
  "name[cont]": zod.string().optional(),
  "name[start]": zod.string().optional(),
  "name[end]": zod.string().optional(),
  "order_number[eq]": zod.string().optional(),
  "order_number[ne]": zod.string().optional(),
  "order_number[in]": zod.array(zod.string()).optional(),
  "order_number[nin]": zod.array(zod.string()).optional(),
  "order_number[null]": zod.boolean().optional(),
  "order_number[cont]": zod.string().optional(),
  "order_number[start]": zod.string().optional(),
  "order_number[end]": zod.string().optional(),
  "revision_code[eq]": zod.string().optional(),
  "revision_code[ne]": zod.string().optional(),
  "revision_code[in]": zod.array(zod.string()).optional(),
  "revision_code[nin]": zod.array(zod.string()).optional(),
  "revision_code[null]": zod.boolean().optional(),
  "revision_code[cont]": zod.string().optional(),
  "revision_code[start]": zod.string().optional(),
  "revision_code[end]": zod.string().optional(),
  "assigned_to": zod.array(zod.int()).optional(),
  "criticality": zod.enum(['Undefined', '1', '1 (Low)', '1 (Medium)', '1 (High)', '2', '2 (Low)', '2 (Medium)', '2 (High)', '3', '3 (Low)', '3 (Medium)', '3 (High)', '99', '99 (Low)', '99 (Medium)', '99 (High)']).optional(),
  "id": zod.array(zod.int()).optional(),
  "identifier_like": zod.string().optional(),
  "is_threat": zod.boolean().optional(),
  "material_group": zod.array(zod.int()).optional(),
  "offers_presence": zod.enum(['with_offers', 'without_offers']).optional(),
  "plant": zod.array(zod.int()).optional(),
  "purchase_group": zod.array(zod.int()).optional(),
  "quantity": zod.number().optional(),
  "reference_number": zod.string().optional(),
  "renegotiation": zod.boolean().optional(),
  "requisition_date": zod.iso.date().optional(),
  "segment": zod.array(zod.int()).optional(),
  "status": zod.array(zod.string()).optional(),
  "type": zod.enum(['automatic', 'assisted']).optional(),
  "urgency": zod.string().optional(),
  "order[assigned_to.full_name_with_login]": zod.string().optional(),
  "order[created_at]": zod.string().optional(),
  "order[id]": zod.string().optional(),
  "order[identifier]": zod.string().optional(),
  "order[material.short_description]": zod.string().optional(),
  "order[material_group.name]": zod.string().optional(),
  "order[plant.plant_number]": zod.string().optional(),
  "order[purchase_group.name]": zod.string().optional(),
  "order[quantity]": zod.string().optional(),
  "order[segment.name]": zod.string().optional(),
  "order[status]": zod.string().optional(),
  "order[type]": zod.string().optional(),
  "order[urgency]": zod.string().optional(),
  "items_per_page": zod.int().min(1).max(listQuotationsParamsItemsPerPageMax).default(listQuotationsParamsItemsPerPageDefault),
  "page": zod.int().default(listQuotationsParamsPageDefault)
})

export type ListQuotationsParams = zod.input<typeof ListQuotationsParams>;
export type ListQuotationsParamsOutput = zod.output<typeof ListQuotationsParams>;
